import { SUPPORTED_INVERTER_VENDORS } from '../../../ps-types';

type VendorIntegrationStatus = 'available' | 'beta' | 'not-available';

export interface Vendor {
  id: string;
  name: string;
  logo: string;
  color?: string;
  integrationStatus: VendorIntegrationStatus;
}

export const VENDOR_LIST: Vendor[] = SUPPORTED_INVERTER_VENDORS.map(vendor => {
    switch(vendor) {
      case 'SUNGROW-AUSTRALIA':
        return {
          id: 'SUNGROW-AUSTRALIA',
          name: 'Sungrow (Australian Region)',
          logo: '/am-logos/integrations/energy-devices/sungrow-logo.png',
          color: '#FF6B35', // Sungrow's signature orange
          integrationStatus: 'beta'
        }
      case 'SUNGROW':
        return {
          id: 'SUNGROW',
          name: 'Sungrow',
          logo: '/am-logos/integrations/energy-devices/sungrow-logo.png',
          color: '#FF6B35', // Sungrow's signature orange
          integrationStatus: 'beta'
        }
      case 'ENPHASE':
        return {
          id: 'ENPHASE',
          name: 'Enphase',
          logo: '/am-logos/integrations/energy-devices/enphase-logo.png',
          color: '#1E3A8A', // Enphase's deep blue
          integrationStatus: 'available'
        }
      case 'FRONIUS':
        return {
          id: 'FRONIUS',
          name: 'Fronius',
          logo: '/am-logos/integrations/energy-devices/fronius-logo.png',
          color: '#DC2626', // Fronius's red
          integrationStatus: 'available'
        }
      case 'GOODWE':  
        return {
          id: 'GOODWE',
          name: 'Goodwe',
          logo: '/am-logos/integrations/energy-devices/goodwe-logo.png',
          color: '#059669', // Goodwe's green
          integrationStatus: 'available'
        }
      case 'GROWATT':
        return {
          id: 'GROWATT',
          name: 'Growatt',
          logo: '/am-logos/integrations/energy-devices/growatt-logo.png',
          color: '#7C3AED', // Growatt's purple
          integrationStatus: 'available'
        }   
      case 'SOLAREDGE':
        return {
          id: 'SOLAREDGE',
          name: 'SolarEdge',
          logo: '/am-logos/integrations/energy-devices/solaredge-logo.svg',
          color: '#00A3E0', // SolarEdge's blue
          integrationStatus: 'available'
        }
      case 'HUAWEI':
        return {
          id: 'HUAWEI',
          name: 'Huawei',
          logo: '/am-logos/integrations/energy-devices/huawei-logo.png',
          color: '#CF1322', // Huawei's red
          integrationStatus: 'available'
        }
      case 'SMA':
        return {
          id: 'SMA',
          name: 'SMA',
          logo: '/am-logos/integrations/energy-devices/sma-logo.png',
          color: '#1E40AF', // SMA's blue
          integrationStatus: 'available'
        }
        default:
          return {
            id: vendor,
            name: vendor,
            logo: '🔌',
            color: '#6435C9',
            integrationStatus: 'not-available'
          }
    }
  }
)